export default __webpack_public_path__ + "static/media/image100.26cbc381.svg";